const COURSE_TYPES = new Set([
  'grammar',
  'vocabulary',
  'listening-course',
  'reading-course',
  'writing-course',
  'speaking-course',
]);

const stripHtml = (value) =>
  String(value || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const asArray = (value) => (Array.isArray(value) ? value : []);

const questionsFrom = (lesson) =>
  asArray(lesson.exercises).flatMap((exercise) => asArray(exercise.questions));

const scoredQuestions = (lesson) =>
  questionsFrom(lesson).filter(
    (question) =>
      question &&
      (question.answer != null ||
        question.acceptedAnswers ||
        question.example)
  );

export const auditLessonContract = (lesson = {}) => {
  const issues = [];
  const overview = lesson.overview || {};
  const sections = asArray(lesson.sections);
  const exercises = asArray(lesson.exercises);
  const tips = asArray(lesson.tips);
  const dailyPractice = asArray(lesson.dailyPractice);
  const questions = scoredQuestions(lesson);
  const teachingChars = sections.reduce(
    (total, section) => total + stripHtml(section.content).length,
    0
  );
  const hasSupport = sections.some(
    (section) =>
      asArray(section.examples).length > 0 || asArray(section.points).length > 0
  );
  const genericExplanations = questions.filter((question) =>
    /The expected answer is/i.test(String(question.explanation || ''))
  ).length;
  const realExplanations = questions.filter(
    (question) =>
      question.explanation &&
      !/The expected answer is/i.test(question.explanation) &&
      stripHtml(question.explanation).length >= 20
  ).length;

  if (!overview.impact || !overview.focus || !overview.uses || !overview.duration) {
    issues.push('missing-overview');
  }
  if (sections.length < 3) issues.push('few-sections');
  if (teachingChars < 600) issues.push('thin-teaching');
  if (!hasSupport) issues.push('no-examples-or-points');
  if (questions.length < 8) issues.push('few-questions');
  if (exercises.length < 2) issues.push('few-exercises');
  if (genericExplanations > 0) issues.push('generic-explanations');
  if (realExplanations < Math.min(8, questions.length)) {
    issues.push('thin-explanations');
  }
  if (tips.length < 3) issues.push('few-tips');
  if (dailyPractice.length < 3) issues.push('few-daily-practice');
  if (!String(lesson.aiContext || '').trim()) issues.push('missing-ai-context');
  if (!COURSE_TYPES.has(lesson.courseType)) issues.push('invalid-course-type');
  if (!String(lesson.backPath || '').startsWith('/exams/english')) {
    issues.push('invalid-back-path');
  }

  return {
    courseId: lesson.courseId,
    title: lesson.title,
    issues,
    teachingChars,
    questions: questions.length,
    sections: sections.length,
    exercises: exercises.length,
  };
};

export const lessonMeetsContract = (lesson) =>
  auditLessonContract(lesson).issues.length === 0;
